import styled from "styled-components";
import Button from 'components/Button';

const ContainerSubtotalMenu = styled.div`
  width: 200px;
  min-height: 100px;
  background: linear-gradient(210.55deg, #353A40 -3.02%, #121416 93.08%);
  box-shadow: 36px 12px 64px rgba(2, 3, 3, 0.7), -12px -20px 56px rgba(232, 237, 243, 0.05), inset -16px -6px 80px rgba(248, 249, 249, 0.03);
  border-radius: 10px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  top: 70%;
  padding: 10px;
  @media only screen and (max-width: 768px) {
    top: 70%;
  }
`;

const ContainerSubtotalAmount = styled.div`
  width: 100%;
  display: flex;
  align-items: space-between;
  justify-content: space-between;
`;

const ViewCartButton = styled(Button)`
    width: 200px;
    max-width: 100%;
    height: 40px;
    border-radius: 400px;
    font-family: Khula;
    font-style: normal;
    font-weight: bold;
    font-size: 15px;
    line-height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    color: #D6E1EF;
    opacity: 0.95;
    margin-top: 10px;
    &:hover{
      opacity: 1;
    }
    @media only screen and (max-width: 768px) {
        margin-top: 5px;
        width: 100%;
        flex-shrink: 0;
        margin-top: 10px;
    }
`;

const ClearCartButton = styled.div`
  margin: auto;
  margin-top: 10px;
  font-family: Khula;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 130%;
  /* identical to box height, or 16px */
  
  display: flex;
  align-items: center;
  text-align: center;
  letter-spacing: 0.02em;
  font-feature-settings: 'ordn' on, 'cpsp' on;
  
  color: rgba(214, 225, 239, 0.5);
  text-shadow: -1px -1px 2px rgba(255, 255, 255, 0.1), 1px 1px 3px #1E2226;
`

export default {
  ContainerSubtotalMenu,
  ContainerSubtotalAmount,
  ViewCartButton,
  ClearCartButton,
}
